export default {
  SET_BURGER_MENU_STATE(state, payload) {
    state.burgerMenuState = payload
  },
  SET_Z_INDEX_BLOCK(state, payload) {
    state.zIndexBlock = payload
  },
  SET_PACKAGES(state, payload) {
    state.packages = payload
  },
  SET_PACKAGES_LOADING(state, payload) {
    state.packagesLoading = payload
  },
  SET_ACTIVE_HEADER_SECTION(state, payload) {
    state.activeHeaderSection = payload
  },
}
